module.exports = __webpack_public_path__ + "img/norcraft.1fc9774b.png";